/**
 * The two demo properties. These stay analyzable LOGGED OUT so a first-time visitor
 * can see real output before signing up; every other address requires an account.
 *
 * Mirrors api_cost_control.SAMPLE_DEAL_ADDRESSES on the backend (substring match on a
 * normalized address). Keep the two in sync.
 */
export const SAMPLE_DEALS = {
  flip: {
    address: '553 Belmont St, Detroit, MI 48202',
    askingPrice: 89000,
  },
  rental: {
    address: '227 Marlborough St, Detroit, MI',
    askingPrice: 75000,
  },
};

// Same stems the backend matches on.
const SAMPLE_PATTERNS = ['553 belmont', '227 marlborough'];

const normalize = (address) =>
  String(address || '')
    .toLowerCase()
    .replace(/[.,#]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

/** True when this address is one of the free demo properties. */
export const isSampleAddress = (address) => {
  const n = normalize(address);
  return SAMPLE_PATTERNS.some((p) => n.includes(p));
};

/**
 * A visitor must register before analyzing their OWN address.
 *
 * Before this gate every logged-out visitor was sent to the backend as the literal
 * user_id 'guest', so they all shared ONE 3-analysis lifetime bucket — which was
 * already spent (5/3). New arrivals hit the upgrade wall on their very first action
 * and never saw the product. Signed-in users get their own quota keyed to their
 * real user_id.
 */
export const requiresSignupToAnalyze = (user, address) => {
  const signedIn = !!(user && user.user_id && user.user_id !== 'guest');
  if (signedIn) return false;
  return !isSampleAddress(address);
};

export default { SAMPLE_DEALS, isSampleAddress, requiresSignupToAnalyze };
